import { render, staticRenderFns } from "./PrePage.vue?vue&type=template&id=43600ed2&scoped=true&"
import script from "./PrePage.vue?vue&type=script&lang=js&"
export * from "./PrePage.vue?vue&type=script&lang=js&"
import style0 from "./PrePage.vue?vue&type=style&index=0&id=43600ed2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43600ed2",
  null
  
)

export default component.exports